import React, { Component } from 'react'
import styled from 'styled-components'
import { fluidType, device } from '../../../utils/helpers'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

const Wrapper = styled.div`
  display: none;
  position: absolute;
  top: ${props => props.isSmaller ? '95px' : '115px'};
  ${''}
  z-index: 10000;

  @media ${device.tablet} {
    width: ${props => props.name === 'noleggia' ? '550px' : '600px'};
    left: ${props => props.name === 'noleggia' ? '18.2vw' : '19vw'};
    top: ${props => props.isSmaller ? '85px' : '115px'};
    top: ${props => props.isStrutture && '95px'};
  }

  @media (min-width: 912px) {
    left: ${props => props.name === 'noleggia' ? '18.8vw' : '20vw'};
  }

  @media (min-width: 1090px) {
    left: 21vw;
  }

  @media ${device.laptop} {
    width: ${props => props.name === 'noleggia' ? '700px' : '780px'};
    left: ${props => props.name === 'noleggia' ? '21.5w' : '22.5vw'};
  }

  @media ${device.laptopL} {
    width: ${props => props.name === 'noleggia' ? '700px' : '920px'};
    left: 20.5vw;
  }

  @media ${device.desktop} {
    top: ${props => props.isSmaller ? '95px' : '115px'};
    width: ${props => props.name === 'noleggia' ? '700px' : '920px'};
    left: 20vw;
  }
`

const Arrow = styled.div`
  width: 0;
  height: 0;
  margin-left: ${props => props.name === 'noleggia' ? '160px' : '260px'};
  ${''/* margin-left: 9vw; */}
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid ${props => props.theme.color.bgYellow};

  @media ${device.laptop} {
    margin-left: ${props => props.name === 'noleggia' ? '160px' : '300px'};
  }

  @media ${device.laptopL} {
    margin-left: ${props => props.name === 'noleggia' ? '160px' : '325px'};
  }

  @media ${device.desktop} {
    margin-left: ${props => props.name === 'noleggia' ? '160px' : '320px'};
  }
`

const Header = styled.ul`
  display: grid;
  list-style: none;
  grid-template-columns: ${props => props.name === 'noleggia' ? 'repeat(3, 1fr)' : 'repeat(4, minmax(160px, 1fr))'};
  padding: 0.8em;
  background-color: ${props => props.theme.color.bgYellow};
  color: #fff;
`

const Content = styled.div`
  display: grid;
  grid-template-columns: ${props => props.name === 'noleggia' ? 'repeat(3, 1fr)' : 'repeat(4, minmax(160px, 1fr))'};
  padding: 1em;
  font-family: 'BarlowSemiBold';
  ${fluidType('480px', '1920px', '12px', '18px')};
  background-color: #f1f1f1;
`

const HeaderLink = styled(Link)`
  text-decoration: none;
  color: #fff;

  &:hover {
    text-decoration: underline;
  }
`

const HeaderA = styled.a`
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`

const ContentLink = styled(Link)`
  text-decoration: none;
  color: #4d4d4d;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const ContentA = styled.a`
  text-decoration: none;
  color: #4d4d4d;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const List = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
`

const ListItem = styled.li`
  padding: 5px 0;
`

class Submenu extends Component {
  render () {
    const { items, name } = this.props
    const { pathname } = this.props.location
    // Routes where default height should be 100px
    const smallerNavRoutes = ['strutture', 'noleggia']
    return (
      <Wrapper name={name.toLowerCase()} isStrutture={pathname.includes('strutture')} isSmaller={smallerNavRoutes.some(route => pathname.includes(route))}>
        <Arrow name={name.toLowerCase()} />
        <Header name={name.toLowerCase()}>
          {items.headers.map(item => (
            <li key={item.name}>{item.url.includes('noleggia') ? <HeaderLink to={item.url}>{item.name}</HeaderLink> : <HeaderA href={item.url}>{item.name}</HeaderA>}</li>
          ))}
        </Header>
        <Content name={name.toLowerCase()}>
          {items.lists.map((listItem, index) => (
            <List key={index}>
              {listItem.map(item => (
                <ListItem key={item.name}>
                  {item.url.includes('noleggia') ? <ContentLink to={item.url}>{item.name}</ContentLink> : <ContentA href={item.url}>{item.name}</ContentA>}
                </ListItem>
              ))}
            </List>
          ))}
        </Content>
      </Wrapper>
    )
  }
}

export default withRouter(Submenu)



// WEBPACK FOOTER //
// ./src/components/UI/Header/Submenu.js